import { render, staticRenderFns } from "./ListadoSolicitudPreventa.vue?vue&type=template&id=21d93d19&scoped=true"
import script from "./ListadoSolicitudPreventa.vue?vue&type=script&setup=true&lang=js"
export * from "./ListadoSolicitudPreventa.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ListadoSolicitudPreventa.vue?vue&type=style&index=0&id=21d93d19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d93d19",
  null
  
)

export default component.exports